import {ButtonGroup} from 'platform/components';
import {Box, HStack, Heading, Text, VStack} from 'platform/foundation';

import {forwardRef} from 'react';

import i18n from '@dms/i18n';

import {SignaturePad, SignaturePadHandle} from './SignaturePad';

interface SignerBlockProps {
  heading: string;
  signatureError: string | null;
  isSubmitting: boolean;
  onClear: () => void;
}

export const SignerBlock = forwardRef<SignaturePadHandle, SignerBlockProps>(
  function SignerBlock(props, ref) {
    return (
      <VStack spacing={3}>
        <Heading size={4}>{props.heading}</Heading>
        <VStack spacing={1}>
          <HStack spacing={2} align="flex-end">
            <Text size="xSmall" color="tertiary">
              {i18n.t('page.checklistAudits.signModal.signature')}
            </Text>
            <Text size="xSmall" color="tertiary">
              {i18n.t('page.checklistAudits.signModal.signatureHelp')}
            </Text>
          </HStack>
          <SignaturePad
            ref={ref}
            ariaLabel={i18n.t('page.checklistAudits.signModal.signature')}
            isDisabled={props.isSubmitting}
          />
          {props.signatureError ? (
            <Text size="xSmall" color="danger">
              {props.signatureError}
            </Text>
          ) : null}
          <Box>
            <ButtonGroup
              align="left"
              buttons={[
                {
                  title: i18n.t('page.checklistAudits.signModal.clear'),
                  leftIcon: 'action/delete',
                  variant: 'ghostLink',
                  onClick: props.onClear,
                  isDisabled: props.isSubmitting,
                },
              ]}
            />
          </Box>
        </VStack>
      </VStack>
    );
  }
);
